var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAnalyticsUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 9,
    viewBox: "0 0 7 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.91848 1.14406C3.11235 0.925937 3.42668 0.925937 3.62055 1.14406C3.81442 1.36219 3.81442 1.71584 3.62055 1.93397L1.05841 4.81666C0.864537 5.03479 0.550211 5.03479 0.35634 4.81666C0.16247 4.59854 0.16247 4.24488 0.35634 4.02676L2.91848 1.14406Z",
    fill: "#0CBD5B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.21014 4.0268C6.40401 4.24493 6.40401 4.59858 6.21014 4.8167C6.01627 5.03483 5.70194 5.03483 5.50807 4.8167L2.94593 1.93401C2.75206 1.71588 2.75206 1.36223 2.94593 1.14411C3.1398 0.92598 3.45413 0.925979 3.648 1.14411L6.21014 4.0268Z",
    fill: "#0CBD5B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.78193 7.4789C3.78193 7.78624 3.56049 8.03538 3.28733 8.03538C3.01417 8.03538 2.79273 7.78624 2.79273 7.4789L2.79273 2.41856C2.79273 2.11122 3.01417 1.86208 3.28733 1.86208C3.56049 1.86208 3.78193 2.11122 3.78193 2.41856L3.78193 7.4789Z",
    fill: "#0CBD5B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalyticsUp);
export default __webpack_public_path__ + "static/media/analytics-up.ca9954c72cb0f7683ceb2ff409e4fd3b.svg";
export { ForwardRef as ReactComponent };